// Copia di user-details destinata alla cache offline in localStorage.
//
// Il payload è per la maggior parte immagini base64 sparse un po' ovunque: gli
// avatar degli utenti (~95% della lista utenti), l'avatar e la firma del profilo
// corrente (la sola firma vale ~100KB), i loghi fra le impostazioni. Sono
// inutili al fallback offline — i componenti che mostrano avatar e firma hanno
// già il ripiego — e sono la voce che riempie la quota del dominio, condivisa
// con le cache CRUD.
//
// La regola è una sola e vale a qualsiasi profondità, così un campo immagine
// aggiunto in futuro non torna a gonfiare la cache senza che nessuno se ne
// accorga. Lo store in memoria continua a ricevere il payload completo: qui si
// sfoltisce solo quello che finisce su disco.

export function isBase64Image(value) {
	return typeof value === 'string' && value.indexOf('data:image/') === 0
}

export function stripBase64Images(value) {
	if (isBase64Image(value)) {
		return null
	}

	if (Array.isArray(value)) {
		return value.map(stripBase64Images)
	}

	if (value && typeof value === 'object') {
		const stripped = {}
		Object.keys(value).forEach(key => {
			stripped[key] = stripBase64Images(value[key])
		})
		return stripped
	}

	return value
}

export function cacheableProfile(data) {
	return data ? stripBase64Images(data) : data
}
